<app-loading-overlay />
<router-outlet></router-outlet>
<p-toast />
@if (enabledChatbot()) {
  <app-chatbot-component></app-chatbot-component>
}
